import React, { useState } from 'react'
import { Typography } from '@material-ui/core'
import { Box, Checkbox, TextField, Tooltip } from '@mui/material'
import {
  CheckboxAndLabel,
  Copy,
  InfoIcon,
  LinkInputsContainer,
  Row,
} from './TaskModalV2.styled'
import { OnUpdateOptions } from '../types'

type LinkInputsProps = {
  linkText: string
  linkUrl: string
  onUpdateOptions: OnUpdateOptions
}

export const LinkInputs = ({
  linkText,
  linkUrl,
  onUpdateOptions,
}: LinkInputsProps) => {
  const [isAddingLink, setIsAddingLink] = useState(!!linkText || !!linkUrl)

  const handleAddLinkToggle = () => {
    if (isAddingLink) {
      onUpdateOptions({ key: 'linkUrl', value: null })
      onUpdateOptions({ key: 'linkText', value: null })
    }
    setIsAddingLink(!isAddingLink)
  }

  return (
    <LinkInputsContainer>
      <Row>
        <CheckboxAndLabel>
          <Checkbox checked={isAddingLink} onChange={handleAddLinkToggle} />
          <Copy>Include a Website Link</Copy>
        </CheckboxAndLabel>
        <Tooltip
          title={
            <Box sx={{ p: 2, maxWidth: 300 }}>
              <Typography>
                Add an external link or additional Resilia tools to reference
                while working on this task. The Link Name will appear in the
                Task. Example: Add a Task to &quot;Create an Impact Story,&quot;
                add the link to your Resilia Story draft, and name it &quot;My
                Impact Story&quot;
              </Typography>
            </Box>
          }
          arrow
          placement='right'
        >
          <InfoIcon />
        </Tooltip>
      </Row>
      {isAddingLink && (
        <Box display='flex' gap='24px'>
          <TextField
            id='task-modal-v2-website-link-text-input'
            label='Link Name'
            onChange={({ target }) =>
              onUpdateOptions({ key: 'linkText', value: target.value })
            }
            sx={{ flex: 1 }}
            value={linkText}
          />
          <TextField
            id='task-modal-v2-website-link-url-input'
            label='Link URL'
            onChange={({ target }) =>
              onUpdateOptions({ key: 'linkUrl', value: target.value })
            }
            sx={{ flex: 1 }}
            value={linkUrl}
          />
        </Box>
      )}
    </LinkInputsContainer>
  )
}
